import { notify } from '@/utils/error'
import articleCard from '@/api/articleCard'

export default {
  namespaced: true,

  actions: {
    loadItem: ({ rootState }, data) => {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        const filters = data ? data.filters : {}
        articleCard.get({ businessUnitId, articleId: data.article, filters })
          .then(response => {
            const item = response.data.items[0]
            resolve(item)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    getPdf ({ rootState }, data) {
      return new Promise((resolve, reject) => {
        // add print type
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        const filters = data ? data.filters : {}
        articleCard.getPdf({ businessUnitId, articleId: data.article, filters })
          .then(response => {
            const pdfData = response.data.items[0]
            resolve(pdfData)
          })
          .catch(error => reject(error))
      })
    }
  }
}
